import FirebaseAuthProvider from "./firebase-auth-provider";

export default class TwitterAuthProvider extends FirebaseAuthProvider {
  constructor(firebaseConfig) {
    super('twitter', firebaseConfig);
  }

  authorize() {
    const providerSerive = new firebase.auth.TwitterAuthProvider();

    firebase
      .auth()
      .signInWithPopup(providerSerive)
      .then((result) => {
        // Аватар в данных от Twitter может располагаться в нескольких местах
        let avatarUrl =
          (result.additionalUserInfo && result.additionalUserInfo.profile && result.additionalUserInfo.profile.profile_image_url_https) ||
          (result.user.providerData[0] && result.user.providerData[0].photoURL) ||
          result.user.profile_image_url_https;

        this.trigger({
          type: 'providerAuthorized',
          data: {
            provider: this.name,
            userData: {
              userID: result.user.uid,
              name: result.user.displayName,
              avatarUrl: avatarUrl
            }
          }
        });
      })
      .catch((error) => {
        // Думаю, что здесь стоит воспользоваться механизмом отправки сообщений об ошибках
        // Что показывать пользователю? Сделать отдельный попап с сообщением об ошибке?

        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        console.log({ error });
      });

    firebase.auth().onAuthStateChanged((user) => {
      // Если пользователь больше не авторизован
      if (!user) {
        this.chatApi.socialNetworkDeauthorized();
      }
    });
  }
}
